const Other = [
  {
    label: "Motivačný dokument",
    semester: "",
    data: "./documents/Other/Motivacne_listy.pdf",
    date: "13.9.2021",
    
  },
  {
    label: "Zápisnica šablóna",
    semester: "",
    data: "./documents/Other/Zapisnica_sablona.pdf",
    date: "04.10.2021",
    
  },
  {
    label: "Šprint šablóna",
    semester: "",
    data: "./documents/Other/Sprinty_sablona_2.pdf",
    date: "13.9.2021",
    
  },
  {
    label: "Prihláška na TP CUP",
    semester: "",
    data: "./documents/Other/Prihlaska_TP_CUP.pdf",
    date: "26.10.2021",
    
  },
  {
    label: "Milnik 1",
    semester: "",
    data: "./documents/Other/Team_01_Milnik_1.pdf",
    date: "22.11.2021",
    
  },
  {
    label: "Milnik 2 (ZS)",
    semester: "",
    data: "./documents/Other/Team_01_ZS.pdf",
    date: "14.12.2021",
    
  },
  {
    label: "Finalná Dokumentácia (LS)",
    semester: "",
    data: "./documents/Other/Tim_01_Full_Docu.pdf",
    date: "13.05.2022",
    
  },
  {
    label: "IIT SRC článok",
    semester: "",
    data: "./documents/Other/IIT_SRC.pdf",
    date: "09.04.2022",
    
  },
  {
    label: "Blog",
    semester: "",
    data: "./documents/Other/blog.pdf",
    date: "08.05.2022",
    
  },
  {
    label: "Krátky opis",
    semester: "",
    data: "./documents/Other/shortdescription.pdf",
    date: "08.05.2022",
    
  },
  {
    label: "Externé testovanie",
    semester: "",
    data: "./documents/Other/nav-x-testing.pdf",
    date: "08.05.2021",
    
  }
]

export default Other;
